import { forwardRef, InputHTMLAttributes } from 'react';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
    containerClassName?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
    function SearchInput({ containerClassName, className, ...props }, ref) {
        return (
            <div
                className={cn(
                    'flex items-center gap-2 px-2 py-3 border-b border-grey-500',
                    containerClassName,
                )}
            >
                <MagnifyingGlassIcon className="w-4 h-4 text-grey-400" />
                <input
                    {...props}
                    ref={ref}
                    className={cn(
                        'flex-1 bg-transparent text-sm text-white-100 placeholder:text-grey-400 outline-none',
                        className,
                    )}
                />
            </div>
        );
    },
);
